import { Size } from '@optimus-web/common';

export const getDasharray = (r: number, value: number) => {
    const circumstance = 2 * Math.PI * r;
    return `${value * circumstance}, ${circumstance}`;
};

export const getSizeProperties = (size: Size) => {
    switch (size) {
        case 'small':
            return {
                dimension: 24,
                radius: 9,
                strokeWidth: 2,
            };
        case 'medium':
            return {
                dimension: 40,
                radius: 15,
                strokeWidth: 3.33333,
            };
        case 'large':
            return {
                dimension: 56,
                radius: 21,
                strokeWidth: 4.66667,
            };
    }
};
